import React from "react";
import Container from "../../../Components/Admin/Container";
import Img from "../../../Components/Img";
import Destaque from "../../../Assets/Images/destaque-admin.png";

const HomePageAdmin = () => {
    return (
        <Container pageTitle="Página Inicial">
            <Img src={Destaque} width="1200px" height="600px" />
        </Container>
    );
};

export default HomePageAdmin;
